export default __webpack_public_path__ + "static/media/pin-talk3.a42d4758.png";